import React, { useEffect, useState } from "react";
import { Snackbar, Alert } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { clearLocalSession, logoutUser } from "../../../utils/api";

const Logout = () => {
  const navigate = useNavigate();
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("error");

  const handleSnackbarClose = () => {
    setOpenSnackbar(false);
  };

  useEffect(() => {
    const handleLogout = async () => {
      try {
        await logoutUser();

        setSnackbarMessage("You have been logged out");
        setSnackbarSeverity("success");
        setOpenSnackbar(true);
        setTimeout(() => {
          navigate("/");
        }, 1000);
      } catch (error) {
        console.log(error);

        clearLocalSession();

        setSnackbarMessage(error.message || "An error occurred");
        setSnackbarSeverity("error");
        setOpenSnackbar(true);
        setTimeout(() => {
          navigate("/");
        }, 2000);
      }
    };

    handleLogout();
  }, [navigate]);

  return (
    <>
      <Snackbar
        open={openSnackbar}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
        data-testid="logout--Snackbar-0">
        <Alert
          onClose={handleSnackbarClose}
          severity={snackbarSeverity}
          data-testid="logout--Alert-0">
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </>
  );
};

export default Logout;
